import { DateTime } from "luxon";
import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "typedefs";
import styles from "./styles.module.scss";
import { useTranslation } from "react-i18next";

const ReportListItemWithCoach = ({
  createdAt,
  format,
  reportFileUrl,
  innerRef,
  filters,
}) => {
  const timeZone = useSelector((state: RootState) => state.user.data.timezone);
  const locale = useSelector((state: RootState) => state.user.data.locale);
  const date = DateTime.fromISO(createdAt)
    .setZone(timeZone)
    .setLocale(locale)
    .toFormat("MMM d, yyyy • h:mm a");
  const { t } = useTranslation();

  let periodLabel: string;
  if (filters["snapshotDate"]) {
    periodLabel = DateTime.fromISO(filters["snapshotDate"])
      .setZone(timeZone)
      .toFormat("MMM d, yyyy");
  } else {
    const from = DateTime.fromISO(filters["periodStartDate"])
      .setZone(timeZone)
      .toFormat("MMM d, yyyy");
    const to = DateTime.fromISO(filters["periodEndDate"])
      .setZone(timeZone)
      .toFormat("MMM d, yyyy");
    periodLabel = `${from} - ${to}`;
  }

  return (
    <div ref={innerRef} className={styles.container}>
      <div className={styles.fit_content_width}>{t(date)}</div>
      <div className={styles.fit_content_width}>{t(format.toUpperCase())}</div>
      <div className={styles.fit_content_width}>{t(periodLabel)}</div>
      <div className={styles.fit_content_width}>
        {filters["coachName"] || "-"}
      </div>
      <a href={reportFileUrl}>{t("Download")}</a>
    </div>
  );
};

export default ReportListItemWithCoach;
